import { render, staticRenderFns } from "./TheCenterPanel.vue?vue&type=template&id=4bdf1f39&"
import script from "./TheCenterPanel.vue?vue&type=script&lang=ts&"
export * from "./TheCenterPanel.vue?vue&type=script&lang=ts&"
import style0 from "./TheCenterPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports